import { render, staticRenderFns } from "./contactUsTable.vue?vue&type=template&id=eddb696a&scoped=true&"
import script from "./contactUsTable.vue?vue&type=script&lang=js&"
export * from "./contactUsTable.vue?vue&type=script&lang=js&"
import style0 from "./contactUsTable.vue?vue&type=style&index=0&id=eddb696a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb696a",
  null
  
)

export default component.exports